import React, {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import styles from './style/Header.module.scss';
import MenuButton from './components/MenuButton';
import HeaderLogo from './components/HeaderLogo';
import LinkButton from '../../../components/common/Buttons/LinkButton';
import LoginButton from './components/LoginButton';
import {ReactComponent as Info} from '../../../assets/icon/Info.svg';
import Notifications from './components/Notifications';
import ShoppingCartButton from './components/ShoppingCartButton';
import SearchBar from './components/SearchBar';
import useHomeStore from "../../../store/homeStore";
import useAuthStore from "../../../store/authStore";
import useCartStore from "../../../store/cartStore";
import useSearchStore from "../../../store/searchStore";
import useGetShoppingCartQuery from "../../../queries/useGetShoppingCartQuery";

type PrivateProps = {
  advertisingBannerClick: () => void;
};

export default function Header({advertisingBannerClick}: PrivateProps) {
  const setSearchId = useSearchStore(state => state.setSearchId)

  const setShoppingItems = useCartStore(state => state.setShoppingItems);

  const showPricingModal = useHomeStore(state => state.showPricingModal);
  const showContactModal = useHomeStore(state => state.showContactModal);
  const setShowCart = useHomeStore(state => state.setShowCart);
  const showCart = useHomeStore(state => state.showCart);
  const setShowLogin = useHomeStore(state => state.setShowLogin);
  const showLogin = useHomeStore(state => state.showLogin);
  const showDownloadApiModal = useHomeStore(state => state.showDownloadApiModal);
  const advertisingBannerButtonText = useHomeStore(state => state.advertisingBannerButtonText);

  const isAuthenticated = useAuthStore(state => state.isAuthenticated())

  const navigate = useNavigate();

  const shoppingCart = useGetShoppingCartQuery()

  useEffect(() => {
    if (isAuthenticated) shoppingCart.refetch();
  }, [isAuthenticated]);

  useEffect(() => {
    const data = shoppingCart.data;

    if (!data) return

    setShoppingItems(data.shoppingItems);
  }, [shoppingCart.data, setShoppingItems]);

  const handleCart = () => {
    if (isAuthenticated) {
      setShowCart(!showCart)
    } else {
      setShowLogin(!showLogin)
    }
  }

  return (
    <>
      <header className={styles.header}>
        <div className={styles.left}>
          <HeaderLogo
            onClick={() => {
              navigate('/');
            }}
          />

          <MenuButton
            id="Header-GetStarted_Button"
            onClick={() => {
              navigate('/features');
            }}
            title={'GET STARTED'}
            active={false}
          />

          <MenuButton
            id="Header-Pricing_Button"
            onClick={() => {
              navigate('pricing');
            }}
            title={'Pricing'}
            active={showPricingModal}
          />

          <MenuButton
            id="Header-Contact_Button"
            onClick={() => {
              navigate('/contact');
            }}
            title={'Contact'}
            active={showContactModal}
          />

          <MenuButton
            id="Header-Api_Button"
            onClick={() => {
              navigate('/api');
            }}
            title={'Api'}
            active={showDownloadApiModal}
          />
        </div>
        <div className={styles.right}>
          <div className={styles.linkButtonContainer}>
            {localStorage.getItem('showAdvertisingBanner') === 'true' && (
              <LinkButton
                id="Header-AdvertisingBanner_Button"
                onClick={() => advertisingBannerClick()}
                title={advertisingBannerButtonText || 'Learn more'}
              >
                <Info className={styles.svg}/>
              </LinkButton>
            )}
            <SearchBar
              searchID={(id) => setSearchId(id)}
            />
          </div>

          <div className={styles.iconsContainer}>
            <LinkButton id="Header-Cart_Button" smallHide={true} onClick={handleCart}>
              <ShoppingCartButton/>
            </LinkButton>
            <LinkButton
              id="Header-Notification_Button"
              smallHide={true}
              onClick={() => {
                navigate('/notifications');
              }}>
              <Notifications/>
            </LinkButton>
          </div>
          <LoginButton/>
        </div>
      </header>
    </>
  );
}
